import React, { useState, useEffect } from "react";
import { Col } from "@amzn/stencil-react-components/layout";
import { Input } from "@amzn/stencil-react-components/form";
import {
  MessageBanner,
  MessageBannerType,
} from "@amzn/stencil-react-components/message-banner";
import useArb from "../../../../../hooks/use-arb";
import { H2, Text } from "../../../../../components/typography";
import { updateDocumentId } from "../../requests/requests";
import { AttachmentType } from "../../models";
import { useParams, useHistory } from "react-router-dom";
import { Button } from "@amzn/stencil-react-components/button";
import {
  deleteCachedRequest,
  getCandidateData,
} from "../../../../../utility/candidate-data";

export function NSSUploadLayout() {
  const bundle = useArb("HVHChecklistPantherResource");
  const nssNumberMessage = bundle.getMessage("Checklist-NSS-Number-Title");
  const documentImageSubmitMessage = bundle.getMessage(
    "Checklist-Document-Image-Submit-ButtonText"
  );
  const documentIdUploadDependencyServiceErrorMessage = bundle.getMessage(
    "Checklist-Document-ID-General-Error-Message"
  );
  const [nssNumber, setNSSNumber] = useState<string>("");
  const [nssSubmitButton, setnssSubmitButton] = useState<boolean>(true);
  const validateNSS = new RegExp("^[0-9]{11}$");

  const { requisitionId, applicationId, isEdit } = useParams<{
    requisitionId: string;
    applicationId: string;
    isEdit: string;
  }>();

  const nssTitleMessage =
    isEdit == "false"
      ? bundle.getMessage("Checklist-NSS-Title")
      : bundle.getMessage("Checklist-NSS-Number-Title");
  const history = useHistory();

  const backToMainPage = () => {
    const path = `/checklist/${requisitionId}/${applicationId}`;
    history.push(path);
  };
  const [currentNSSId, setCurrentNSSId] = useState<string>("");
  const [
    idUploadDependencyServiceErrorMessage,
    setIdUploadDependencyServiceErrorMessage,
  ] = useState<string>();

  useEffect(() => {
    getCandidateData(applicationId)
      .then((res) => {
        if (res.additionalNationalIds[AttachmentType.NSS]?.idNumber) {
          setCurrentNSSId(
            res.additionalNationalIds[AttachmentType.NSS].idNumber
          );
        }
      })
      .catch((err) => console.log(err));
  });

  const stars = "***************";

  useEffect(() => {
    setnssSubmitButton(!validateNSS.test(nssNumber));
  }, [nssNumber]);

  const clickEventSubmitDocument = async () => {
    let returnToMainPage = true;

    try {
      await updateDocumentId({
        applicationId,
        idData: {
          nationalIdType: AttachmentType.NSS,
          idNumber: nssNumber,
        },
      });
    } catch (err) {
      console.log(err);
      setIdUploadDependencyServiceErrorMessage(
        documentIdUploadDependencyServiceErrorMessage
      );
      returnToMainPage = false;
    }

    deleteCachedRequest(applicationId); // delete stale data so that updated Id loads on home page
    if (returnToMainPage) {
      backToMainPage();
    }
  };

  return (
    <Col gridGap={12} maxWidth={"330px"} padding={"10px 24px"}>
      <H2 fontWeight={"bold"}>{nssTitleMessage}</H2>
      <Text>
        {nssNumberMessage} <strong style={{ color: "red" }}>*</strong>
      </Text>
      <Input
        placeholder={
          currentNSSId ? stars + currentNSSId.slice(-4) : nssTitleMessage
        }
        onChange={(e) => setNSSNumber(e.target.value)}
        maxLength={11}
      ></Input>{" "}
      {/* this will need to be corrected later*/}
      {idUploadDependencyServiceErrorMessage ? (
        <MessageBanner type={MessageBannerType.Error}>
          {idUploadDependencyServiceErrorMessage}
        </MessageBanner>
      ) : null}
      <Button
        aria-disabled={nssSubmitButton}
        onClick={clickEventSubmitDocument}
      >
        {documentImageSubmitMessage}
      </Button>
    </Col>
  );
}
